var map = {
	"./LOGO_LabourD3.png": "a312",
	"./Maps_1LongPing.jpg": "e350",
	"./Maps_1LongPing_bak.jpg": "5727",
	"./Maps_2Tin Sau.jpg": "035e",
	"./Maps_3ShauKeiWan.jpg": "ecd4",
	"./Maps_4TaiPoMarket.jpg": "4dfc",
	"./Maps_5KwunTong.jpg": "e46f",
	"./Maps_6EastTST.jpg": "46bd",
	"./Maps_7LaiChiKok.jpg": "395a",
	"./Maps_8WanChai.jpg": "1bf7",
	"./about.jpg": "a46c",
	"./add.png": "d1da",
	"./avatar.png": "1195",
	"./avatar.svg": "bc28",
	"./bed.png": "2c5b",
	"./children.png": "2667",
	"./children1.png": "50e1",
	"./contacten.png": "d755",
	"./contactzh.png": "a8fb",
	"./doc.png": "405c",
	"./edit.png": "aa93",
	"./edit.svg": "6582",
	"./elder.png": "f300",
	"./email.png": "9afb",
	"./email.svg": "9055",
	"./email1.svg": "4a93",
	"./en.png": "70ff",
	"./fb.png": "e219",
	"./fb1.png": "658e",
	"./fben.png": "b366",
	"./fbzh.png": "d389",
	"./filter.svg": "5ee4",
	"./footeren.png": "5735",
	"./footerf.png": "e210",
	"./footerl.png": "1769",
	"./footerzh.png": "aab4",
	"./heart.svg": "fbe8",
	"./heart1.svg": "7573",
	"./heartred.svg": "cdf6",
	"./hkid.png": "5dc4",
	"./img/snow.png": "bfc9",
	"./img/sock.png": "d4fb",
	"./img/tree.png": "cf11",
	"./index11en.png": "5a8d",
	"./index11zh.png": "25bd",
	"./index12en.png": "e8ab",
	"./index12zh.png": "b13a",
	"./index1en11.png": "37cd",
	"./index1zh11.jpg": "d2aa",
	"./index1zh11.png": "6bb1",
	"./index2.jpg": "190d",
	"./index2en1.png": "9d8b",
	"./index2zh1.png": "0cdd",
	"./index3-newyear.png": "1842",
	"./index3-sd.png": "c031",
	"./index3.png": "b580",
	"./index4-newyear.png": "059e",
	"./index4-sd.png": "f40e",
	"./index4.png": "26f3",
	"./index5-newyear.png": "bdf6",
	"./index5-sd.png": "2aa4",
	"./index5.png": "8749",
	"./indexsd1en.jpg": "1271",
	"./indexsd1zh.jpg": "1df0",
	"./indexsd2en.jpg": "b22c",
	"./loc.png": "ffb4",
	"./logo.jpg": "b640",
	"./logo1.png": "534f",
	"./money.png": "875b",
	"./moneyen.png": "07e39",
	"./more.png": "69f5",
	"./mp3/jinglebells.mp3": "c61a",
	"./no.png": "3fff",
	"./p1.png": "f6c2",
	"./p2.png": "84e7",
	"./p3.png": "7dc7",
	"./payment_ATM.png": "0744",
	"./payment_FPS.png": "1694",
	"./paypay.png": "9c7f",
	"./pp.png": "fa46",
	"./ppzh.png": "67f9",
	"./process_detail1.png": "2a5b",
	"./process_detail2.png": "40fd",
	"./process_detail3.png": "efe4",
	"./processing_cn-01.jpg": "a2aa",
	"./processing_en-01.jpg": "3aa2",
	"./qiu.png": "beca",
	"./renew.png": "b573",
	"./renewen.png": "7702",
	"./renewzh.png": "ab3c",
	"./sd-Deng.png": "cf04",
	"./sd-Hat.png": "ebb8",
	"./sendfileen.png": "b0a5",
	"./sendfilezh.png": "5ead",
	"./servicecn.jpeg": "52df",
	"./servicecn.png": "277b",
	"./serviceen.png": "e4c6",
	"./serviceenNew.png": "aa92",
	"./servicesen.png": "8c0b",
	"./serviceszh.png": "bf1f",
	"./signin.jpg": "b7c8",
	"./skin/indexnewyear1en.jpg": "5897",
	"./skin/indexnewyear1zh.jpg": "8b02",
	"./skin/indexnewyear2en.png": "0c88",
	"./slogo.png": "f14b",
	"./solidUser.png": "e628",
	"./style/carousel-item.css": "a8a4",
	"./style/carousel.css": "0b30",
	"./style/color.css": "27e0",
	"./style/date-picker.css": "4cb8",
	"./style/dropdown-item.css": "6b14",
	"./style/dropdown-menu.css": "a25d",
	"./style/dropdown.css": "8bd4",
	"./style/el.css": "b9e0",
	"./style/index.css": "2046",
	"./style/input.css": "46d3",
	"./style/layout.css": "7867",
	"./style/link.css": "d9c8",
	"./style/loading.css": "5677",
	"./style/pagination.css": "da21",
	"./style/radio-button.css": "0db4",
	"./style/radio.css": "06fc",
	"./style/select.css": "982b",
	"./style/step.css": "097b",
	"./style/steps.css": "ac5d",
	"./tc.png": "12ba",
	"./tczh.png": "e854",
	"./user.svg": "0f62",
	"./w.png": "8d5f",
	"./waen.png": "506c",
	"./wahtsapp_cn.jpg": "9e00",
	"./wazh.png": "e170",
	"./whatsapp.png": "9673",
	"./whatsapp_en.jpg": "e0eb",
	"./whatsen.png": "e967",
	"./whatszh.png": "a622",
	"./yes.png": "8254",
	"./youtube.png": "e63a",
	"./zh.png": "b46b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";